<template>
  <div>
    <b-button v-if="records && records.length > 1" variant="primary" class="float-right btn-label btn-sm" v-b-modal="'diff-modal'">
      <i class="bx bx-git-branch label-icon font-size-16"></i>
      {{ $t("inventory-history.get-diff") }}
    </b-button>
    <b-modal id="diff-modal" :title="$t('inventory-history.get-diff')" title-class="font-18">
      <div>
        <label>{{ $t("inventory-history.source") }}</label>
        <filter-select ref="sourceFilter" :placeholder="$t('inventory-history.source')" :multiple="false" @changed="sourceFilterChanged" @filter="filterData" />

        <label class="mt-3">{{ $t("inventory-history.target") }}</label>
        <filter-select ref="targetFilter" :placeholder="$t('inventory-history.target')" :multiple="false" @changed="targetFilterChanged" @filter="filterData" />
      </div>
      <template #modal-footer>
        <div class="w-100">
          <b-button @click="$bvModal.hide('diff-modal')" variant="secondary" class="btn-label float-right btn-sm">
            <i class="bx bx-window-close label-icon"></i>
            {{ $t("common.close") }}
          </b-button>

          <b-button class="btn-label float-right btn-sm mr-1" variant="primary" @click="getDiff()" :disabled="!diffAvailable">
            <i class="bx bx-download label-icon font-size-16"></i>

            {{ $t("inventory-history.get-diff") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div></template
>

<script>
import DirectoryType from "./file-directory-types.vue";

export default {
  props: ["records"],
  components: { DirectoryType },

  data() {
    return {
      selectedSource: undefined,
      selectedTarget: undefined,
    };
  },
  watch: {},
  computed: {
    diffAvailable() {
      return this.selectedSource && this.selectedTarget && this.selectedSource._id != this.selectedTarget._id && this.selectedSource.type == this.selectedTarget.type;
    },
    state() {
      return `${this.currentProduct == "GDPR" ? "gdprInventory" : "kvkkInventory"}`;
    },
  },
  methods: {
    async getDiff(saveInsteadofDownload = false) {
      try {
        const { data: file } = await this.$store.dispatch(`${this.state}/downloadDiff`, { saveInsteadofDownload, source: this.selectedSource, target: this.selectedTarget });
        this.download(file);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async download(item) {
      this.$store.commit("fileManager/addDownloadedFile", { file: item });
    },

    async filterData(value, callback) {
      if (this.records) {
        this.records = this.records.filter((i) => i.directoryType == "INVENTORY");

        callback(
          this.records.map((i) => ({
            ...i,
            name: `${i.name?.[this.currentLanguage]} - ${i.uploader.name}`,
          }))
        );
      } else {
        callback([]);
      }
    },
    sourceFilterChanged(record) {
      this.selectedSource = record;
    },
    targetFilterChanged(record) {
      this.selectedTarget = record;
    },
  },
};
</script>
